import { render, staticRenderFns } from "./AxList.vue?vue&type=template&id=a0e0d80e&scoped=true&"
import script from "./AxList.vue?vue&type=script&lang=ts&"
export * from "./AxList.vue?vue&type=script&lang=ts&"
import style0 from "./AxList.vue?vue&type=style&index=0&id=a0e0d80e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e0d80e",
  null
  
)

export default component.exports